import { LoadingButton } from "../loadingButton";
import { resetTurnstile, waitForTurnstilePromiseOrTimeout } from "../turnstile";
import { TimeoutError } from "../utils";
// Change email functionality
export function setupChangeEmail() {
    document.whenHtmlElementExists("updateEmailForm", "newEmail", "changeEmailBtn", "successMessageEmailChange", "errorMessageEmailChange", (form, newEmail, changeEmailBtn, successMessageEmailChange, errorMessageEmailChange) => {
        newEmail.addEventListener("keypress", (event) => {
            if (event.key !== "Enter") {
                newEmail.classList.remove("is-invalid");
                errorMessageEmailChange.bootstrapHide();
            }
        });
        changeEmailBtn.addEventListener("click", async (event) => {
            const errorMessageEmailChangeText = document.getRequiredHtmlElementById("errorMessageText");
            const notificationLoadingButton = LoadingButton.getOrCreateInstance(changeEmailBtn);
            notificationLoadingButton.start();
            event.preventDefault();
            try {
                // Simple email validation
                const email = newEmail.value.trim();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    // Show alert error
                    newEmail.classList.add("is-invalid");
                    errorMessageEmailChange.bootstrapShow();
                    errorMessageEmailChangeText.innerHTML = "Please enter a valid email address.";
                    return;
                }
                // Reset messages
                errorMessageEmailChange.bootstrapHide();
                successMessageEmailChange.bootstrapHide();
                // Let's wait for either the turnstile promise to resolve or a timeout of 10 seconds
                await waitForTurnstilePromiseOrTimeout(10000);
                const formData = new FormData(form);
                const data = new URLSearchParams();
                formData.forEach((value, key) => {
                    data.append(key, value.toString());
                });
                const result = await fetch("/dashboard/changeemail", {
                    body: data,
                    method: "POST",
                });
                if (result.status === 200) {
                    document.whenHtmlElementExists("updateEmailForm", (updateEmailForm) => {
                        updateEmailForm.bootstrapHide();
                    });
                    successMessageEmailChange.bootstrapShow();
                }
                else {
                    const errorJson = await result.json();
                    let errorString = "";
                    if ("TurnstileValidation" in errorJson) {
                        errorString =
                            "Our anti-automation thinks you're a bot, which you're obviously not! Try behaving like a human and clicking the button again and if it still misbehaves, give the page a reload.";
                    }
                    else {
                        for (const key in errorJson) {
                            const keyItem = errorJson[key];
                            // Let's check if keyItem is a string array
                            if (Array.isArray(keyItem)) {
                                errorString += `${keyItem.join("<br>")}`;
                            }
                        }
                    }
                    errorMessageEmailChange.bootstrapShow();
                    errorMessageEmailChangeText.innerHTML = errorString;
                }
            }
            catch (error) {
                if (error instanceof TimeoutError) {
                    errorMessageEmailChangeText.innerHTML =
                        "Our anti-automation seems to have timed out. Try again or reload the page. If the issue persists, try retrying the operation through an incognito/in-private browser window.";
                }
                else {
                    errorMessageEmailChangeText.innerHTML = `Error during email change: ${error instanceof Error ? error.message : "Unknown error"}`;
                }
                errorMessageEmailChange.bootstrapShow();
            }
            finally {
                // Stop loading button
                notificationLoadingButton.stop();
                resetTurnstile();
            }
        });
    });
}
